<template>
  <div class="seaducts">
    <div class="seaducts-background">
      <div class="seaducts-search">
        <div class="seaducts-search-relvus">
          <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        </div>
        <div class="seaducts-search-retval">
          <form action="">
            <el-input type="search" v-model="Secoarnt" @keyup.enter.native="sekerdch()"></el-input>
          </form>
        </div>
        <button class="seaducts-search-srah" @click="sehfodts()">搜索</button>
      </div>
      <div class="seaducts-histry">搜索历史</div>
      <div class="seaducts-recaod">
        <span v-for="ersehistds in sehistds" :key="ersehistds.value" @click="secnrmoy(ersehistds)">{{ersehistds}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      Secoarnt: '',
      sehistds: [],
      maluerID: ''
    }
  },
  created () {
    // 从缓冲中获取商城的标识
    this.maluerID = localStorage.getItem("usmago");
    if(this.maluerID == '0'){
      this.sehistds = JSON.parse(localStorage.getItem("seithsry") || '[]');
    }else if(this.maluerID == '1'){
      this.sehistds = JSON.parse(localStorage.getItem("seithsal") || '[]');
    }
    
  },
  mounted () {

  },
  methods: {
    // 键盘回车被触发
    sekerdch(){
      this.sehfodts();
    },
    // 点击搜索历史触发
    secnrmoy(seform){
      this.Secoarnt = seform;
      this.$router.push({name: 'pructrch', query: {sefructs: this.Secoarnt}});
    },
    // 点击搜索触发
    sehfodts(){
      if(this.Secoarnt){
        // 把历史搜索加入缓存
        if(this.sehistds.indexOf(this.Secoarnt) == '-1'){
          if(this.sehistds.length >= 10){
            this.sehistds.splice(0,1);
          }
          this.sehistds.push(this.Secoarnt);
          if(this.maluerID == '0'){
            localStorage.setItem('seithsry',JSON.stringify(this.sehistds));
          }else if(this.maluerID == '1'){
            localStorage.setItem('seithsal',JSON.stringify(this.sehistds));
          }
        }
        this.$router.push({name: 'pructrch', query: {sefructs: this.Secoarnt}});
      }
    },
    // 点击返回上一层
    BackLevel(){
      if(this.maluerID == '0'){
        this.$router.push({name: 'shopmall'});
      }else if(this.maluerID == '1'){
        this.$router.push({name: 'pointsal'});
      }
    }
  }
}
</script>

<style scoped>
  @import "obraocs/seaducts.css";
</style>